import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { store } from '@store';

const PrivateRoute = ({ children, ...rest }) => {
    const navigate = useNavigate();
    const { user } = store.getState();
    const isAllowed = useMemo(
        () =>
            rest.isPrivate === false ||
            (rest.isPrivate === true && user && user.id !== '' && rest.roles && !!rest.roles.find((role) => user.role.includes(role))),
        [user, rest.isPrivate, rest.roles],
    );
    React.useEffect(() => {
        if (!isAllowed) {
            navigate('/login');
        }
    }, [isAllowed, navigate]);

    return isAllowed ? children : null;
};

export default PrivateRoute;
